import { render, staticRenderFns } from "./tree_list.vue?vue&type=template&id=2b9e1a72&"
import script from "./tree_list.vue?vue&type=script&lang=js&"
export * from "./tree_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tree_list.vue"
export default component.exports